import script from "./LoadingFullScren.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingFullScren.vue?vue&type=script&setup=true&lang=js"

import "./LoadingFullScren.vue?vue&type=style&index=0&id=4eccc44f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eccc44f"]])

export default __exports__